<div class="reset-password">
  <h2
    class="headline">{{'USER_LIST.MODAL.RESET_PASSWORD_USER' | translate}}</h2>
  <p
    *ngIf="selectedUser.length <= 1"
    class="description">{{'USER_LIST.MODAL.RESET_PASSWORD_DESCRIPTION_1' | translate}}</p>
  <p
    *ngIf="selectedUser.length > 1"
    class="description">{{'USER_LIST.MODAL.RESET_PASSWORD_DESCRIPTION_2' | translate}}</p>
  <h3
    *ngIf="selectedUser.length <= 1"
    class="subtitle">{{userName}}</h3>

  <h3
    *ngIf="selectedUser.length > 1"
    class="subtitle">{{'USER_LIST.MODAL.RESET_PASSWORD_USER_COUNT' | translate}}: {{selectedUser.length}}</h3>
  <div class="btn-block">
    <button
      (click)="resetPassword()"
      class="btn btn-accent">
      {{'USER_LIST.MODAL.RESET_PASSWORD_BUTTON' | translate}}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{'USER_LIST.MODAL.RESET_PASSWORD_CANCEL' | translate}}
    </button>
  </div>
</div>
